"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../../components/Input"));

var _toMoneyFormat = _interopRequireDefault(require("../../utils/toMoneyFormat"));

var _isCalculationPropsEqual = _interopRequireDefault(require("../../utils/isCalculationPropsEqual"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    visibility: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 25px;\n    color: #85878A;\n\n    opacity: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 17px;\n    line-height: 26px;\n    font-weight: 600;\n    white-space: nowrap;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    font-size: 17px;\n    line-height:28px;\n    font-weight: bold;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    padding-left: 8px;\n    font-size: 12px;\n    font-weight: bold;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 40px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    /* margin-bottom: 25px; */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    min-width: 0px;\n    padding: 40px 40px 60px 56px;\n    flex-basis: 320px;\n    max-width: 428px;\n    flex-grow: 1;\n\n    @media (max-width: ", ") {\n        flex-basis: 220px;\n        max-width: 320px;\n    }\n\n    @media (max-width: ", ") {\n        flex-basis: unset;\n        max-width: 100%;\n\n        padding-bottom: 56px;\n        padding-left: 32px;\n        padding-right: 56px;\n\n        border-right: none;\n    }\n\n    @media (max-width: ", ") {\n        padding: 20px 16px;\n    }\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DataSectionStyled = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.breakpointXL;
}, function (props) {
  return props.theme.breakpointLG;
}, function (props) {
  return props.theme.breakpointMD;
});

var DataFieldWrapper = _styledComponents.default.div(_templateObject2());

var DataFieldGroup = _styledComponents.default.form(_templateObject3());

var PaymentFocusStyled = _styledComponents.default.span(_templateObject4());

var PercentPostfixStyled = _styledComponents.default.span(_templateObject5());

var DataSectionTitle = _styledComponents.default.div(_templateObject6());

var DataSectionFootnoteStyled = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.show ? 0 : 1;
});

var DataSectionFictiveSubmitStyled = _styledComponents.default.input(_templateObject8());

var DataSection = function DataSection(props) {
  var setCalculationProps = props.setCalculationProps,
      calculationProps = props.calculationProps,
      calculate = props.calculate,
      isPaymentDisabled = props.isPaymentDisabled,
      isLanding = props.isLanding,
      antikrizis = props.antikrizis;
  var defaultCalculationProps = calculationProps; // "грязные значения" формы

  var _useState = (0, _react.useState)(defaultCalculationProps.employees.toString()),
      _useState2 = _slicedToArray(_useState, 2),
      employees = _useState2[0],
      setEmployees = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _toMoneyFormat.default)(defaultCalculationProps.fot)),
      _useState4 = _slicedToArray(_useState3, 2),
      fot = _useState4[0],
      setFOT = _useState4[1];

  var _useState5 = (0, _react.useState)((0, _toMoneyFormat.default)(defaultCalculationProps.avgPayment)),
      _useState6 = _slicedToArray(_useState5, 2),
      avgPayment = _useState6[0],
      setAvgPayment = _useState6[1];

  var _useState7 = (0, _react.useState)(defaultCalculationProps.contribution.toString()),
      _useState8 = _slicedToArray(_useState7, 2),
      contribution = _useState8[0],
      setContribution = _useState8[1];

  var _useState9 = (0, _react.useState)(defaultCalculationProps.penetration.toString()),
      _useState10 = _slicedToArray(_useState9, 2),
      penetration = _useState10[0],
      setPenetration = _useState10[1]; // Валидационные значения для формы


  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      employeesError = _useState12[0],
      setEmployeesError = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = _slicedToArray(_useState13, 2),
      fotError = _useState14[0],
      setFOTError = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = _slicedToArray(_useState15, 2),
      avgPaymentError = _useState16[0],
      setAvgPaymentError = _useState16[1];

  var _useState17 = (0, _react.useState)(""),
      _useState18 = _slicedToArray(_useState17, 2),
      contributionError = _useState18[0],
      setContributionError = _useState18[1];

  var _useState19 = (0, _react.useState)(""),
      _useState20 = _slicedToArray(_useState19, 2),
      penetrationError = _useState20[0],
      setPenetrationError = _useState20[1]; // Валидна ли форма на лендосе?


  var landingError = isLanding && (contributionError || penetrationError);
  var landingFieldsFilled = Boolean(contribution) || Boolean(penetration); // Валидная ли форма целиком?

  var isError = Boolean(employeesError) || Boolean(fotError) || Boolean(avgPaymentError) || Boolean(contributionError) || Boolean(landingError);
  var valuesFilled = Boolean(employees) || Boolean(fot) || Boolean(avgPayment) || Boolean(contribution) || Boolean(landingFieldsFilled);
  var formIsValid = !isError && valuesFilled; // Если поле "Средняя зарплата" в форме отключено, его значение рассчитывается как ФОТ / штатная численность

  (0, _react.useEffect)(function () {
    if (isPaymentDisabled) {
      var validFot = Number(fot.replace(/\D+|^0+/g, ""));
      var validEmployees = Number(employees.replace(/\D+|^0+/g, ""));
      var newAvgPayment = (0, _toMoneyFormat.default)(validFot / validEmployees);
      setAvgPayment(newAvgPayment);
    }
  }, [employees, fot]); // Кладем триггер в глобальный стейт чтобы вызывать извне (из кнопки)

  (0, _react.useEffect)(function () {
    if (formIsValid) {
      var newCalculationProps = {
        avgPayment: Number(avgPayment.replace(/\D+|^0+/g, "")),
        employees: Number(employees.replace(/\D+|^0+/g, "")),
        contribution: Number(contribution.replace(/\D+|^0+/g, "")),
        fot: Number(fot.replace(/\D+|^0+/g, "")),
        penetration: Number(penetration.replace(/\D+|^0+/g, ""))
      };

      if (!(0, _isCalculationPropsEqual.default)(newCalculationProps, calculationProps)) {
        setCalculationProps(newCalculationProps);
      }
    }
  }, [employees, fot, avgPayment, contribution, penetration]); // валидаторы

  var validateEmployees = function validateEmployees(value) {
    var isNumber = !Number.isNaN(value);

    if (!isNumber || !Boolean(value)) {
      setEmployees("");
      setEmployeesError("Введите количество сотрудников");
      return false;
    }

    setEmployeesError("");
    return true;
  };

  var validateFOT = function validateFOT(value) {
    var isNumber = !Number.isNaN(value);

    if (!isNumber || !Boolean(value)) {
      setFOT("");
      setFOTError("Введите размер фонда оплаты труда");
      return false;
    }

    setFOTError("");
    return true;
  };

  var validateAvgPayment = function validateAvgPayment(value) {
    var isNumber = !Number.isNaN(value);

    if (!isNumber || !Boolean(value)) {
      setAvgPayment("");
      setAvgPaymentError("Введите размер средней ЗП");
      return false;
    }

    setAvgPaymentError("");
    return true;
  };

  var validateContribution = function validateContribution(value) {
    var isNumber = !Number.isNaN(value);

    if (!isNumber || !Boolean(value)) {
      setContribution("");
      setContributionError("Введите индексацию заработной платы");
      return false;
    }

    var percent = Number.parseInt(value);

    if (percent > 12) {
      return false;
    }

    setContributionError("");
    return true;
  };

  var validatePenetration = function validatePenetration(value) {
    var isNumber = !Number.isNaN(value);

    if (!isNumber || !Boolean(value)) {
      setPenetration("");
      setPenetrationError("% участников КПП от штатной численности");
      return false;
    }

    var percent = Number.parseInt(value);

    if (percent > 100) {
      return false;
    }

    setPenetrationError("");
    return true;
  }; // обработчики ввода


  var handleChangeEmployees = function handleChangeEmployees(e) {
    var value = e.currentTarget.value;
    var digitsOnly = value.replace(/\D+|^0+/g, '');
    if (!validateEmployees(digitsOnly)) return;
    var formated = (0, _toMoneyFormat.default)(Number.parseInt(digitsOnly));
    setEmployees(formated);
  };

  var handleChangeFOT = function handleChangeFOT(e) {
    var value = e.currentTarget.value;
    var digitsOnly = value.replace(/\D+|^0+/g, '');
    if (!validateFOT(digitsOnly)) return;
    var formated = (0, _toMoneyFormat.default)(Number.parseInt(digitsOnly));
    setFOT(formated);
  };

  var handleChangeAvgPayment = function handleChangeAvgPayment(e) {
    var value = e.currentTarget.value;
    var digitsOnly = value.replace(/\D+|^0+/g, '');
    if (!validateAvgPayment(digitsOnly)) return;
    var formated = (0, _toMoneyFormat.default)(Number.parseInt(digitsOnly));
    setAvgPayment(formated);
  };

  var handleChangeContribution = function handleChangeContribution(e) {
    var value = e.currentTarget.value;
    var digitsOnly = value.replace(/\D+|^0+/g, '');
    if (!validateContribution(digitsOnly)) return;
    setContribution(digitsOnly);
  };

  var handleChangePenetration = function handleChangePenetration(e) {
    var value = e.currentTarget.value;
    var digitsOnly = value.replace(/\D+|^0+/g, '');
    if (!validatePenetration(digitsOnly)) return;
    setPenetration(digitsOnly);
  };

  var paymentPostfix = /*#__PURE__*/_react.default.createElement(PaymentFocusStyled, null, "\u0440\u0443\u0431/\u0433\u043E\u0434");

  var percentPostfix = /*#__PURE__*/_react.default.createElement(PercentPostfixStyled, null, "%");

  return /*#__PURE__*/_react.default.createElement(DataSectionStyled, {
    className: "kpp-calculator__data"
  }, /*#__PURE__*/_react.default.createElement(DataSectionTitle, {
    className: "kpp-calculator__data-title"
  }, "\u0412\u043D\u0435\u0441\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u0447\u0435\u0442\u0430", " ", !isLanding && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), "\u044D\u043A\u043E\u043D\u043E\u043C\u0438\u0438 \u0438 \u0431\u044E\u0434\u0436\u0435\u0442\u0430 \u041A\u041F\u041F")), /*#__PURE__*/_react.default.createElement(DataFieldGroup, {
    className: "kpp-calculator__field-group",
    onSubmit: calculate
  }, /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "employers"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: !isLanding ? "Штатная численность" : "Сотрудников",
    onChange: handleChangeEmployees,
    value: employees,
    error: employeesError,
    maxLength: 16
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(employeesError)
  }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438")), /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "fot"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: !isLanding ? "Общий ФОТ за год" : "ФОП",
    onChange: handleChangeFOT,
    value: fot,
    error: fotError
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(fotError)
  }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043E\u0431\u044A\u0435\u043C \u0424\u043E\u043D\u0434\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u0442\u0440\u0443\u0434\u0430 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445")), isPaymentDisabled ? "" : /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "payment"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: "\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0430",
    postfix: paymentPostfix,
    onChange: handleChangeAvgPayment,
    value: avgPayment,
    error: avgPaymentError
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(avgPaymentError)
  }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0440\u0435\u0434\u043D\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0443\u044E \u0437/\u043F")), isLanding ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "percentPostfix"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: "\u0421\u043E\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    postfix: percentPostfix,
    onChange: handleChangeContribution,
    value: contribution,
    error: contributionError
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(contributionError)
  }, "% \u0441\u043E\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u0437\u043D\u043E\u0441\u043E\u0432 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432"))) : /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "percentPostfix"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: "\u0418\u043D\u0434\u0435\u043A\u0441\u0430\u0446\u0438\u044F \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B",
    postfix: percentPostfix,
    onChange: handleChangeContribution,
    value: contribution,
    error: contributionError
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(contributionError)
  }, "% \u0438\u043D\u0434\u0435\u043A\u0441\u0430\u0446\u0438\u0438")), !antikrizis ? /*#__PURE__*/_react.default.createElement(DataFieldWrapper, {
    id: "percentPostfix"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    title: isLanding ? "Коэффициент проникновения" : "% участников",
    postfix: percentPostfix,
    onChange: handleChangePenetration,
    value: penetration,
    error: penetrationError
  }), /*#__PURE__*/_react.default.createElement(DataSectionFootnoteStyled, {
    show: Boolean(penetrationError)
  }, "% \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u041A\u041F\u041F \u043E\u0442 \u0448\u0442\u0430\u0442\u043D\u043E\u0439 \u0447\u0438\u0441\u043B\u0435\u043D\u043D\u043E\u0441\u0442\u0438")) : '', /*#__PURE__*/_react.default.createElement(DataSectionFictiveSubmitStyled, {
    type: "submit"
  })));
};

DataSection.propTypes = {
  setCalculationProps: _propTypes.default.func.isRequired,
  calculate: _propTypes.default.func.isRequired,
  isPaymentDisabled: _propTypes.default.bool.isRequired,
  isLanding: _propTypes.default.bool.isRequired,
  antikrizis: _propTypes.default.bool.isRequired
};
var _default = DataSection;
exports.default = _default;